<template>
	<Modal
		:is-open="isOpen"
		hide-container
		@update:is-open="(newValue: boolean) => isOpen = newValue"
	>
		<div class="px-4 pt-20 pb-4">
			<div class="typo-h3 mb-6 lg:mb-10 text-body-secondary text-center">
				Kde najdete údaje na vaší účtence:
			</div>

			<ReceiptExampleTabs class="lg:hidden" />
			<div class="bg-background-secondary rounded-lg py-2 px-6 hidden lg:grid lg:grid-cols-2 gap-6 font-secondary font-semibold text-body-secondary text-center">
				<figure>
					<figcaption class="mb-2">
						Kompletní účtenka
					</figcaption>
					<NuxtImg
						format="webp"
						src="/images/receipt.png"
						sizes="sm:100vw inf:442px"
						loading="lazy"
						width="442"
						height="545"
					/>
				</figure>
				<figure>
					<figcaption class="mb-2">
						Zkrácená účtenka
					</figcaption>
					<NuxtImg
						format="webp"
						src="/images/receipt-short.png"
						sizes="lg:100vw inf:442px"
						loading="lazy"
						width="442"
						height="462"
					/>
				</figure>
			</div>
			<div class="flex justify-center mt-5 lg:mt-9">
				<button class="btn btn-lg btn-primary px-24" @click="isOpen = false">
					Zavřít
				</button>
			</div>
		</div>
	</Modal>
</template>

<script setup lang="ts">
	interface Props {
		isOpen?: boolean;
	}

	const props = defineProps<Props>();
	const emit = defineEmits(['update:isOpen']);
	const isOpen = useVModel(props, 'isOpen', emit);
</script>
